<ion-header translucent>
  <ion-toolbar *ngIf="showLogin">
    <ion-title class="custom-title">{{'_connect_fb_' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">{{'_cancel_' | translate}}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<div class="inner-content">
  <section class="fb-container-skeleton flex-column justify-center align-center" *ngIf="!showLogin && !imageLoaded">
    <ion-thumbnail class="fb-image">
      <ion-skeleton-text animated></ion-skeleton-text>
    </ion-thumbnail>
    <ion-skeleton-text animated class="fb-title"></ion-skeleton-text>
    <ion-skeleton-text animated class="fb-sub-title"></ion-skeleton-text>
  </section>
  <section class="fb-container" *ngIf="showLogin">
    <div class="step fb-confirmation" *ngIf="!pages">
      <img class="fb-bg" src="./assets/image/facebook-fan-page@2x.jpg" alt="Facebook Fan Page"
           (load)="imageLoaded = true">
      <div class="message" *ngIf="pageResponse">
        <h2>{{'_hi_' | translate}}</h2>
        <p>{{'_please_connect_facebook_' | translate}}</p>
      </div>
      <div class="message" *ngIf="!pageResponse">
        <h2>{{'_error_' | translate}}</h2>
        <p>{{title}}</p>
      </div>
      <ion-button class="ion-padding" expand="full" shape="round" size="medium" (click)="pageLogin()">
        <ion-icon name="facebook" slot="start"></ion-icon>
        {{'_connect_' | translate}}
      </ion-button>
    </div>
    <div class="step fbprofile-list" *ngIf="pages">
      <ion-item class="title" lines="none">
        <ion-icon name="facebook" slot="start"></ion-icon>
        <ion-label>{{title}}</ion-label>
      </ion-item>
      <div class="fb-page-list" *ngFor="let page of pages"
           (click)="selectPage(page)" lines="none">

        <div style="display: flex;gap: 10px">
          <div>
            <img src="{{page.picture.data.url}}" alt="{{page.name}}-page-image"/>
          </div>
          <div>
            <div class="page-title">
              {{page.name}}
            </div>
          </div>
        </div>


        <div *ngIf="page.instagram_account" class="instagram-section" >

          <ion-icon name="logo-instagram"></ion-icon>

          <div class="instagram-info">
            <div>
              <img src="{{page?.instagram_account?.profile_picture_url }}">
            </div>
            <div>
              {{ page?.instagram_account?.name }}
            </div>
          </div>
        </div>


      </div>
      <div class="fb-list-nav clearfix">
        <div *ngIf="prevList" (click)="loadMorePages('prev')" class="prev"><i
          class="icon-arrow-left"></i>&nbsp;{{'_archive_' | translate}}
        </div>
        <div *ngIf="nextList" (click)="loadMorePages('next')" class="next">{{'_next_' | translate}}&nbsp;<i
          class="icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </section>
</div>

